import {PinProtect} from '~/features/Auth/PinProtect';

import {DiscountCodes} from '~/features/Premium';

export const DiscountCodesScreen = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <DiscountCodes />
      </PinProtect>
    </div>
  );
};
